// Swipeable image gallery for product cards.
// The swipe itself is left untouched. Once a swipe has fully settled, the card's photo area
// eases to the shape of the photo now showing, so taller photos aren't cropped and the
// name/price glide down (or back up) without fighting the swipe.
if (!customElements.get('card-gallery')) {
  class CardGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.card-gallery__track');
      this.slides = Array.from(this.querySelectorAll('.card-gallery__slide'));
      this.dots = this.querySelectorAll('.card-gallery__dot');
      this.count = this.slides.length;
      if (!this.track || this.count < 2) return;

      this.inner = this.closest('.card__inner');
      this.card = this.closest('.card');
      this.ratios = this.slides.map((slide) => {
        const img = slide.querySelector('img');
        const w = img && (Number(img.getAttribute('width')) || img.naturalWidth);
        const h = img && (Number(img.getAttribute('height')) || img.naturalHeight);
        return w && h ? (h / w) * 100 : null;
      });
      this.current = 0;

      this.onScroll = this.onScroll.bind(this);
      this.onSettled = this.onSettled.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      if ('onscrollend' in window) this.track.addEventListener('scrollend', this.onSettled);

      this.querySelectorAll('.card-gallery__arrow').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.go(button.classList.contains('card-gallery__arrow--next') ? 1 : -1);
        });
      });
    }

    disconnectedCallback() {
      if (!this.track) return;
      this.track.removeEventListener('scroll', this.onScroll);
      this.track.removeEventListener('scrollend', this.onSettled);
      clearTimeout(this.timer);
    }

    get index() {
      const width = this.track.clientWidth || 1;
      return Math.min(this.count - 1, Math.max(0, Math.round(this.track.scrollLeft / width)));
    }

    go(step) {
      const next = (this.index + step + this.count) % this.count;
      this.track.scrollTo({ left: next * this.track.clientWidth, behavior: 'smooth' });
    }

    onScroll() {
      // Wait for the swipe (and its snap) to finish before changing any size.
      clearTimeout(this.timer);
      this.timer = setTimeout(this.onSettled, 150);
    }

    onSettled() {
      clearTimeout(this.timer);
      const i = this.index;
      this.dots.forEach((dot, k) => dot.classList.toggle('is-active', k === i));
      if (i === this.current) return;
      this.current = i;
      const percent = this.ratios[i];
      if (!percent) return;
      const value = percent.toFixed(3) + '%';
      if (this.inner) this.inner.style.setProperty('--ratio-percent', value);
      if (this.card) this.card.style.setProperty('--ratio-percent', value);
    }
  }
  customElements.define('card-gallery', CardGallery);
}
